/** @format */

import React, { useEffect, useState } from 'react'
import { Stack } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'

import FormDiagnostico from '../../pages/registroMedicos/incapacidad/FormDiagnostico'
import { OBSTETRICOS, SLICES_NAMES } from '../../constants'

export const FormWithSpeechObservaciones = () => {
  const { datosGenerales } = useSelector((state) => state.obstetrico)

  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()
  const [editorContent, setEditorContent] = useState('')

  useEffect(() => {
    if (!isLoading && datosGenerales) {
      setEditorContent(datosGenerales?.notas)
      setIsLoading(true)
    }
  }, [dispatch, isLoading, datosGenerales])
  return (
    <Stack>
      <FormDiagnostico
        title="Observaciones"
        trans={editorContent}
        sliceName={SLICES_NAMES.OBSTETRICO}
        propertySliceName={OBSTETRICOS.DATOS_GENERALES}
      />
    </Stack>
  )
}
